/**
 * Recently Viewed Products functionality
 * This script handles tracking and displaying recently viewed products
 */

window.Shopify = window.Shopify || {};

Shopify.Products = (function() {
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-products",
    templateId: "recently-template",
    viewedId: "products_viewed_block",
    onComplete: null
  };
  
  var productHandleQueue = [];
  var viewedContainer = null;
  var productList = null;
  var template = null;
  var shown = 0;
  
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname
    },
    name: "shopify_recently_viewed",
    write: function(productHandles) {
      $.cookie(this.name, productHandles.join(" "), this.configuration);
    },
    read: function() {
      var handles = [];
      var cookieValue = $.cookie(this.name);
      if (cookieValue !== null && typeof cookieValue !== "undefined") {
        handles = cookieValue.split(" ");
      }
      return handles;
    },
    destroy: function() {
      $.cookie(this.name, null, this.configuration);
    },
    remove: function(productHandle) {
      var handles = this.read();
      var position = $.inArray(productHandle, handles);
      if (position !== -1) {
        handles.splice(position, 1);
        this.write(handles);
      }
    }
  };
  
  var finalize = function() {
    if (productList.show) {
      productList.show();
    }
    
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {
        // Ignore errors in the onComplete callback
      }
    }
  };
  
  var moveAlong = function() {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      $.ajax({
        dataType: "json",
        url: "/products/" + productHandleQueue[0] + ".js",
        cache: false,
        success: function(product) {
          viewedContainer.show();
          template.tmpl(product).appendTo(productList);
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function() {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      finalize();
    }
  };
  
  return {
    resizeImage: function(src, size) {
      if (size === null) {
        return src;
      }
      
      if (size === "master") {
        return src.replace(/http(s)?:/, "");
      }
      
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
      
      if (match !== null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        
        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      }
      
      return null;
    },
    
    showRecentlyViewed: function(params) {
      var params = params || {};
      
      // Update config
      $.extend(config, params);
      
      // Read cookie
      productHandleQueue = cookie.read();
      
      // Get elements
      template = $("#" + config.templateId);
      productList = $("#" + config.wrapperId);
      viewedContainer = $("#" + config.viewedId);
      
      // Don't show if we don't have any products or template
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
      
      if (config.howManyToShow && template.length && productList.length) {
        moveAlong();
      }
    },
    
    getConfig: function() {
      return config;
    },
    
    clearList: function() {
      cookie.destroy();
    },
    
    recordRecentlyViewed: function(params) {
      var params = params || {};
      
      // Update config
      $.extend(config, params);
      
      // Read cookie
      var productHandles = cookie.read();
      
      // If we are on a product page
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // Get the product handle from the URL
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        
        // In case the product handle is already in the cookie
        var position = $.inArray(productHandle, productHandles);
        
        // If not in the cookie or at the front of it
        if (position === -1) {
          // Add the product to the start of the list
          productHandles.unshift(productHandle);
          // Only keep what we need
          productHandles = productHandles.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product from the list
          productHandles.splice(position, 1);
          // Add it to the start of the list
          productHandles.unshift(productHandle);
        }
        
        // Update the cookie
        cookie.write(productHandles);
      }
    }
  };
})();

// Initialize recently viewed products tracking when the page loads
$(document).ready(function() {
  Shopify.Products.recordRecentlyViewed();
});